import { createStore, createEffect, createEvent, combine } from 'effector';
import { ApiUtils } from '@shared/utils';
import { RecipientsApi, RequestStrategyEnum, type WithSignal, type RecipientResponse } from '@shared/api';

const getRecipientByIdEffect = createEffect(({ signal, ...request }: WithSignal<{ id: string }>) => RecipientsApi.getRecipient(request.id, signal));
const clearEvent = createEvent();

const $dataStore = createStore<RecipientResponse | null>(null)
  .on(getRecipientByIdEffect.done, (current, data) => data.result.data ?? current)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getRecipientByIdEffect.pending, (_, data) => data)
  .on(getRecipientByIdEffect.fail, (_, data) => ApiUtils.abortApiLoadingFailCaseTrigger(data.error))
  .on(getRecipientByIdEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getRecipientByIdEffect, () => null)
  // .on(getRecipientByIdEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getRecipientByIdEffect.fail, (_, data) => {
    if (data.error.message === 'Action is forbidden.') return 'Action is forbidden.';
    if (data.error.message === "'Id' must not be empty.") return 'Action is forbidden.';
    return 'Something went wrong while fetching Recipient. Please try again.';
  })
  .on(getRecipientByIdEffect.done, () => null)
  .reset(clearEvent);

const getRecipientByIdApi = ApiUtils.wrapperApi(getRecipientByIdEffect, RequestStrategyEnum.Abort);
clearEvent.watch(() => getRecipientByIdApi.cancel());

export const $recipientByIdStore = {
  events: {
    getRecipient: getRecipientByIdApi.trigger,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
